/* tslint:disable */
/* eslint-disable */
/**
 * Supply API Gateway
 * A REST API responsible to serve and compose all supply-related data available at Taster
 *
 * The version of the OpenAPI document: 1.63
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * Check if a given object implements the IncomingDeliveries interface.
 */
export function instanceOfIncomingDeliveries(value) {
    let isInstance = true;
    isInstance = isInstance && "nbDeliveries" in value;
    isInstance = isInstance && "nbProducts" in value;
    return isInstance;
}
export function IncomingDeliveriesFromJSON(json) {
    return IncomingDeliveriesFromJSONTyped(json, false);
}
export function IncomingDeliveriesFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'nbDeliveries': json['nb_deliveries'],
        'nbProducts': json['nb_products'],
        'nextDeliveryDate': !exists(json, 'next_delivery_date') ? undefined : (json['next_delivery_date'] === null ? null : new Date(json['next_delivery_date'])),
    };
}
export function IncomingDeliveriesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'nb_deliveries': value.nbDeliveries,
        'nb_products': value.nbProducts,
        'next_delivery_date': value.nextDeliveryDate === undefined ? undefined : (value.nextDeliveryDate === null ? null : value.nextDeliveryDate.toISOString().substr(0, 10)),
    };
}
